import { Container, Heading, Box, ContainerProps } from '@hover/blueprint';
import React from 'react';
import styled from '@emotion/styled';
import { ScreenReaderText } from '..';

interface Props extends ContainerProps {
  numberOfSlides: number;
  header: string;
  description: string;
  screenReaderText: string;
}

const StyledHeading = styled(Heading)`
  @media (max-height: 690px) {
    margin-bottom: 0;
  }
`;

const HoInvitedBetterWayToBuildContainer: React.FC<Props> = ({
  children,
  numberOfSlides,
  header,
  description,
  screenReaderText,
  ...restProps
}) => (
  <Container
    maxW="8xl"
    d="flex"
    alignItems="flex-start"
    justifyContent="center"
    role="region"
    aria-label="Slideshow"
    {...restProps}
  >
    <ScreenReaderText content={screenReaderText} />
    <Box
      d="flex"
      flexDir="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      position="sticky"
      top="110px"
      h={{ base: 'auto', desktop: '100vh' }}
      maxW={{ base: '100%' }}
    >
      <Container alignItems="center" maxW="4xl" px={200}>
        <StyledHeading
          maxW="4xl"
          marginBottom={500}
          size={{ base: 500, tablet: 700 }}
          textAlign="center"
          isLight
          as="h2"
        >
          {header}
        </StyledHeading>
        <Heading
          as="p"
          size={{ base: 200, tablet: 500 }}
          isDisplay
          textAlign="center"
        >
          {description}
        </Heading>
      </Container>
      {children}
    </Box>
    <Box
      w={0}
      height={{ base: 0, desktop: `${(numberOfSlides + 1) * 100}vh` }}
      id="build-container"
    />
  </Container>
);

export default HoInvitedBetterWayToBuildContainer;
